module.exports = __webpack_public_path__ + "static/media/diamonds.fda686e4.svg";